import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['childCount', 'agesForm']

  displayForm() {
    this.removeCurrentAges()

    let childCount = parseInt(this.childCountTarget.value)
    let agesForm = this.agesFormTarget
    agesForm.classList.toggle('hidden', childCount == 0)

    _(childCount).times(function() {
      let ageField = document.querySelector('.js-child-age').cloneNode(true)
      ageField.disabled = false
      agesForm.firstElementChild.appendChild(ageField)
    })
  }

  closeForm(e) {
    this.agesFormTarget.classList.add('hidden');
    e.preventDefault();
  }

  removeCurrentAges() {
    document
      .querySelectorAll('.js-child-age:not([disabled])')
      .forEach(el => el.parentNode.removeChild(el))
  }
}
